import Save from './Save';

export default Save;